const Section_Description = ({description}) => (
  <div
    className="pt-2 pb-10 mx-20 sm:mx-40"
    dangerouslySetInnerHTML={{__html: description}}
  />
);

export default Section_Description;
